module.exports = __webpack_public_path__ + "static/img/4.251297d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/4.png
// module id = fVOa
// module chunks = 0